<template>
  <div>
    <Header />
    <div class="container contentContainer" style="display: flex;flex-wrap:wrap;">
      <!-- <Ad /> -->
      <div class="left">
        <Sidebar :category="category" :packageCate="packageCate" />
      </div>
      <div class="right">
        <Products
          :category="category"
          :products="products"
          :packages="packages"
          :packageCate="packageCate"
        />

        <Cart />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/sidebar.vue';
import Products from '@/components/products.vue';
import Header from '@/components/header.vue';
import Cart from '@/components/cart.vue';
// import Ad from '@/components/ad.vue';

export default {
  components: {
    Header,
    Sidebar,
    Products,
    Cart,
    // Ad,
  },
  data() {
    return {};
  },
  computed: {
    category() {
      return this.$store.state.category;
    },
    products() {
      return this.$store.state.products;
    },
    packages() {
      return this.$store.state.packages;
    },
    packageCate() {
      return this.$store.state.packageCate;
    },
  },
  created() {
    this.$store.dispatch('GET_ALL_PRODUCT');
  },
};
</script>

<style></style>
